<link rel="stylesheet" type="text/css" href="/css/style/policy.css">
<div class="policy bg-light" id="policy_top">
    <div class="policy__container">
        <div class="policy_header">
            <h1>PRIVACY POLICY</h1>
            <h1>OF THE EMODUL MOBILE APPLICATION</h1>
        </div>
        <div class="row"></div>
        <div class="policy_navigation_menu">
            1. <a class="link" (click)="appAlert.scrollTo('Introduction')">Introduction</a>
            <br />
            2. <a class="link" (click)="appAlert.scrollTo('ContractDetails')">Administrator Details. Contact details.</a>
            <br />
            3. <a class="link" (click)="appAlert.scrollTo('AboutEModul')">What is eModul</a>
            <br />
            4. <a class="link" (click)="appAlert.scrollTo('AboutPolicy')">Information on the security policy</a>
            <br />
            5. <a class="link" (click)="appAlert.scrollTo('DataCollection')">The data we collect. Mode of data collection.</a>
            <br />
            6. <a class="link" (click)="appAlert.scrollTo('DataUsage')">Method of data processing</a>
            <br />
            7. <a class="link" (click)="appAlert.scrollTo('YourRights')">Your rights related to data processing</a>
            <br />
            8. <a class="link" (click)="appAlert.scrollTo('StoringData')">Data storage</a>
            <br />
            9. <a class="link" (click)="appAlert.scrollTo('SharingData')">Data sharing. Data transfer to third countries.</a>
            <br />
            10. <a class="link" (click)="appAlert.scrollTo('DisagreementLaw')">Right to object</a>
            <br />
            11. <a class="link" (click)="appAlert.scrollTo('Petition')">Complaint to the supervisory authority.</a>
        </div>
        <div class="policy_body>">
            <div class="policy_paragraph">
                <h1 id="Introduction">1. INTRODUCTION</h1>
                <p class="content">
                    Thank you for selecting the eModul application! We make every effort to ensure that eModul meets
                    all your expectations, therefore, one of our highest priorities is your privacy and the security of the
                    data you entrust us. In order to ensure them, we have created a document called the eModul Mobile
                    Application Privacy Policy. Please read the Policy carefully before using eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="ContractDetails">2. INFORMATION ON THE ADMINISTRATOR OF EMODUL: CONTACT DETAILS</h1>
                <p class="content">
                    The administrator of Personal Data collected via the eModul application is the company TECH
                    STEROWNIKI spółka z ograniczoną odpowiedzialnością spółka komandytowa, with registered
                    office in Wieprz, at ul. Biała Droga 31, 34-122 Wieprz, NIP 551 23 60 632, REGON 356782780,
                    KRS 0000594881. We encourage you to contact us in all matters that are relevant to you. How to
                    contact us:
                </p>
                <table class="policy_contact_details_table">
                    <tr>
                        <td>By e-mail:</td>
                        <td>poczta&#64;techsterowniki.pl </td>
                    </tr>
                    <tr class="separating_line">
                        <td>Traditional mail:</td>
                        <td>ul. Biała Droga 31, 34-122 Wieprz </td>
                    </tr>
                    <tr class="separating_line">
                        <td>By Telephone:</td>
                        <td>+48 33 330 00 07 </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutEModul">3. WHAT IS EMODUL</h1>
                <h2>3.1</h2>
                <p class="content">
                    eModul is an application dedicated to support controllers cooperating with modules of the ST-505
                    and Wi-Fi families. By using eModul you can:
                </p>
                <ul class="pp_list">
                    <li>obtain a preview of all the current parameters of the controller and edit these parameters;</li>
                    <li>view the history of temperatures and alarms;</li>
                    <li>control many modules from a single account;</li>
                    <li>receive e-mail notifications about current alarms.</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <h2>3.2</h2>
                <p class="content">
                    The use of eModul is free of charge, but requires drivers compatible with the above-mentioned
                    modules. All data that you provide to us are data for the proper functioning of eModul, for statistical
                    purposes and purposes related to improving the operation of eModul. eModul is intended for people
                    over 13 years of age.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="AboutPolicy">4. POLICY INFORMATION</h1>
                <h2>4.1</h2>
                <p class="content">
                    The Policy contains all the necessary information that governs our relationship with the information
                    you provide. Thus, the basic objective of the Policy is:
                </p>
                <ul class="pp_list">
                    <li>
                        ensuring that at every stage of our cooperation, you will know what data we collect from
                        you, what we do with them and what are your rights;
                    </li>
                    <li>
                        ensuring that your consent to the transmission of data to us is always informed and
                        voluntary.
                    </li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <h2>4.2</h2>
                <p class="content">
                    We are constantly developing and improving eModul, so if we make changes to the application that
                    will affect the scope of collection and processing of the data you provide, we will provide you with
                    additional information, conditions or rules. Shall the new scope of collection and processing be
                    incompatible with your preferences, you will always be able to object to it, which, however, may
                    involve disabling eModul on your device.
                </p>
            </div>

            <div class="policy_paragraph">
                <h2>4.3</h2>
                <p class="content">
                    Despite the lack of changes to eModul, we may periodically change or amend this Policy itself. In
                    the event of such changes, we will inform you about them in a clear and unambiguous manner (e.g.
                    via e-mail). Any changes to the Policy will enter into force at the time that will allow you to freely
                    decide whether you want to continue using eModul despite the implemented changes.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataCollection">5. DATA WE COLLECT. METHOD OF DATA COLLECTION</h1>
                <h2>5.1</h2>
                <p class="content">
                    Below, we have listed the data that we collect from you at every stage of interaction with eModul:
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Stage</th>
                        <th>Category</th>
                        <th>Description</th>
                    </tr>
                    <tr>
                        <td>Register</td>
                        <td>Registration data</td>
                        <td>
                            <p>
                                These are all data that you provide to us during the eModul
                                registration process. The condition for collecting them is that you
                                voluntarily enter them in eModul.
                            </p>
                            <p>
                                The data that we obtain from you at this stage is: email address to
                                verify account registration.
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Registering the module</td>
                        <td>Detailed registration data</td>
                        <td>
                            <p>
                                These are all data that you provide to us in the registration process
                                of the purchased module. The condition for collecting them is that
                                you voluntarily enter them in eModul.
                            </p>
                            <p>
                                The data that we collect from you at this stage are: email address
                                for sending notifications (it may be the same as provided in the
                                registration process), telephone number for sending notifications.
                            </p>
                            <p>
                                During the module registration process, you can provide us with
                                additional data so as to render your eModul account more
                                personalized. In particular, we ask you for your postal code and
                                country, but it is not necessary to provide this data to complete the
                                detailed registration.
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Using eModul</td>
                        <td>Usage data</td>
                        <td>
                            <p>
                                These are all data that we obtain from you in an automated manner
                                while you use eModul.
                            </p>
                            <p>
                                The data that we obtain from you at this stage are: device name,
                                unique device token (used for notifications), device software
                                version, eModul installation country and information about any
                                errors generated by eModul.
                            </p>
                            <p>
                                In its browser version, eModul also applies cookies, which are
                                used only for the purpose of maintaining login (session).
                            </p>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h2>5.2</h2>
                <p class="content">
                    All data collected by us and provided by you in the module registration process are provided
                    voluntarily. Data collected automatically allow us to improve eModul.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DataUsage">6. HOW WE USE THE DATA</h1>
                <h2>6.1</h2>
                <p class="content">
                    Below, we have listed the ways in which we use the data we collect from you:
                </p>
                <table class="policy_details_table">
                    <tr>
                        <th>Category</th>
                        <th>Base</th>
                        <th>Reasons for processing</th>
                    </tr>
                    <tr>
                        <td>Registration data</td>
                        <td>Agreement implementation</td>
                        <td>
                            These data are necessary for the performance of the contract
                            concluded with you, along with logging in to eModul. This
                            agreement concerns the creation of an account in eModul,
                            making it possible to register the controller.
                        </td>
                    </tr>
                    <tr>
                        <td>Detailed registration data</td>
                        <td>Agreement implementation</td>
                        <td>
                            These data are necessary for the performance of the contract
                            concluded with you, along with logging in to eModul. This
                            agreement concerns the provision of eModul functionalities
                            described in item 3 of the Policy.
                        </td>
                    </tr>
                    <tr>
                        <td>Detailed registration data</td>
                        <td>Performance of the Agreement</td>
                        <td>
                            These data are necessary to communicate with you in
                            connection with the alarms appearing in the modules.
                        </td>
                    </tr>
                    <tr>
                        <td>Detailed registration data</td>
                        <td>Your consent</td>
                        <td>
                            In the detailed registration, you can provide us with additional
                            data, including your postal code and country. We use this data
                            for statistical purposes and for purposes related to improving
                            the operation of eModul.
                        </td>
                    </tr>
                    <tr>
                        <td>Usage data</td>
                        <td>Contract performance<br/> <br/>Legitimate interests</td>
                        <td>
                            We use this data for statistical purposes and for purposes
                            related to improving the operation of eModul.
                        </td>
                    </tr>
                </table>
            </div>

            <div class="policy_paragraph">
                <h2>6.2</h2>
                <p class="content">
                    We never apply the data obtained from you to make automatic decisions, including profiling, if the
                    decision may cause legal effects for you or have a similar effect.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="YourRights">7. YOUR RIGHTS RELATED TO DATA COLLECTION</h1>
                <h2>7.1</h2>
                <p class="content">
                    You reserve a number of rights due to the fact that you provide us with your data, including
                    personal data. Therefore, always remember that you are entitled to:
                </p>
                <table class="policy_details_table_no_header">
                    <tr>
                        <td>Right of Access</td>
                        <td>the right to be informed and to request access to the data processed by us.</td>
                    </tr>
                    <tr>
                        <td>Right to rectification</td>
                        <td>the right to request correcting or updating of data that is inaccurate or incomplete.</td>
                    </tr>
                    <tr>
                        <td>Right to deletion</td>
                        <td>the right to request data deletion.</td>
                    </tr>
                    <tr>
                        <td>Right to restrict processing</td>
                        <td>
                            the right to demand that we stop processing all or part of your data temporarily
                            or permanently.
                        </td>
                    </tr>
                    <tr>
                        <td>Right to object</td>
                        <td>
                            the right to object, at any time, to our processing of your data for reasons
                            relating to specific situations.
                        </td>
                    </tr>
                    <tr>
                        <td>Right to transfer</td>
                        <td>
                            the right to request an electronic copy of the data or to transfer it for use by third
                            parties.
                        </td>
                    </tr>
                    <tr>
                        <td>Right of complaint</td>
                        <td>
                            the right to lodge a complaint against the processing of personal data to the
                            supervisory authority, which, in Poland, is the President of the Office for
                            Personal Data Protection.
                        </td>
                    </tr>
                </table>
                <h2>7.2</h2>
                <p>
                    You can exercise all your rights by contacting us, in accordance with the data provided in item 2 of
                    the Policy.
                </p>
            </div>
            <div class="policy_paragraph">
                <h1 id="StoringData">8. DATA STORAGE</h1>
                <h2>8.1</h2>
                <p class="content">
                    We store your data that we process in connection with the performance of the contract and on the
                    basis of a legitimate interest for as long as it is necessary to ensure the use of eModul, and for
                    legitimate and necessary purposes, to comply with legal obligations and to resolve conflicts. Your
                    data will be stored as long as you use eModul, by which we understand the situation in which you
                    notify us of a desire to delete your account. After you cease using eModul, your data will be stored
                    by us for the period of limitation of any claims.
                </p>
            </div>

            <div class="policy_paragraph">
                <h2>8.2</h2>
                <p class="content">
                    We store your data that we process on the basis of your voluntary consent for as long as you do not
                    withdraw your consent. To withdraw your consent, simply use the appropriate eModul functionality
                    or notify us of your intention to delete your account.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="SharingData">9. DATA SHARING TRANSFER OF DATA TO THIRD COUNTRIES</h1>
                <h2>9.1</h2>
                <p class="content">
                    Your data may be shared only in situations where the law allows it. At the moment, we provide for
                    the disclosure of this data only on the basis of a processing entrustment agreement to:
                </p>
                <ul class="pp_list">
                    <li>perators of our IT infrastructure and IT systems;</li>
                    <li>subcontractors helping us to properly fulfil our obligations.</li>
                </ul>
            </div>

            <div class="policy_paragraph">
                <h2>9.2</h2>
                <p class="content">
                    Currently, we have no plans of transferring your data outside the European Economic Area.
                    However, we do not rule out that we may consider it justified in the future. In this case, your data
                    will be secured in the manner required by generally applicable regulations, in particular, through the
                    use of the so-called Standard Contractual Clauses (SCCs).
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="DisagreementLaw">10. RIGHT TO OBJECT</h1>
                <p class="content">
                    Notwithstanding the foregoing, you are entitled to object to the processing of data, which is based
                    on our legitimate interest. In that case:
                </p>
                <ul class="pp_list">
                    <li>if personal data are processed for marketing purposes - we will stop such processing
                        immediately.
                    </li>
                    <li>if the basis for data processing is an interest of a different type - we will cease such
                        processing, unless we are able to demonstrate:
                        <ol type="a">
                            <li>that the said interest overrides your interests, rights and freedoms, or</li>
                            <li>the existence of a basis for establishing, investigating or defending claims is ascertained.</li>
                        </ol>
                    </li>
                </ul>
                <p class="content">
                    The right to object may be exercised, in particular, by sending an appropriate statement in the
                    manner specified in item 13 below.
                </p>
            </div>

            <div class="policy_paragraph">
                <h1 id="Petition">11. COMPLAINT TO THE SUPERVISORY AUTHORITY</h1>
                <p class="content">
                    If you believe that the processing of your data violates applicable law, you have the right to lodge a
                    complaint with the supervisory authority, i.e. President of the Polish Personal Data Protection
                    Office.
                </p>
            </div>

        </div>
    </div>

    <div class="policy__buttons-box">
        <input type="button"
               [value]="subtitles.setSubtitle(1744)"
               class="app-alert__button  bg-ok color-light font-bold font-14 cursor-pointer"
               (click)="appAlert.closePolicy()">
    </div>

</div>

